// extracted by mini-css-extract-plugin
export default {"wrapperCheckbox":"TurkishHavaleHera_wrapperCheckbox__A91mU","checkbox":"TurkishHavaleHera_checkbox__tOhJr"};